module.exports = __webpack_public_path__ + "fonts/NunitoSans-Bold.08e53a5.ttf";